import { callExternalApi } from "./external-api.service";

const tlogApiServerUrl = process.env.REACT_APP_TLOG_API_SERVER_URL;

export const getClubOffersResource = async (clubId, window, accessToken) => {
  const config = {
    url: `${tlogApiServerUrl}/api/offers/getClubOffers`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    data: { clubId, window },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const getCurrentWindowAcceptedOffersResource = async () => {
  const config = {
    url: `${tlogApiServerUrl}/api/offers/getCurrentWindowAcceptedOffers`,
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const updateOfferResource = async (offerId, status, accessToken) => {
  const config = {
    url: `${tlogApiServerUrl}/api/offers/updateOffer`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    data: { offerId, status },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const addOfferResource = async (amount, from, to, playerId, status, window, accessToken) => {
  const config = {
    url: `${tlogApiServerUrl}/api/offers/addOffer`,
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    data: { amount, from, to, playerId, status, window },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};